<template>
  <div class="cart-page__vue">
    <div class="cart-page__content" v-if="count">
      <div class="cart-page__result _finish">
        <TheCartResult page="2"/>
      </div>

      <div class="cart-page__order">
        <TheCartOrderContacts/>
        <!-- Выбор ТК / ПВЗ / курьера (TheCartOrderReceiving) заморожен: покупатель указывает только адрес -->
        <TheCartOrderReceivingAddress/>
        <TheCartOrderPay/>
        <TheCartOrderComment/>

        <div class="cart-page__button-wrap">
          <div class="cart-page__politic text">
            Подтверждая заказ вы соглашаетесь с
            <a :href=politicUrl target="_blank" class="cart-page__politic-link">
              политикой конфиденциальности
            </a>
          </div>

          <a href="javascript:void(0);"
             class="cart-page__button button button__ellipse button_yellow texts texts_button"
             @click="sendOrder" ref="submit"
          >
            Оформить заказ
          </a>

        </div>
        <div class="cart-page__loader-wrap" v-if="loading">
          <div class="cart-page__loader load _visible">
            <hr/><hr/><hr/><hr/>
          </div>
          <div class="cart-page__loader-text">
            {{ loadingText }}
          </div>

        </div>
      </div>
    </div>
    <div class="cart-page__empty" v-else>
      <TheCartEmpty/>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import TheCartPositions from "./TheCartPositions.vue";
import TheCartResult from "./TheCartResult.vue";
import TireTrack from "../icons/TireTrack.vue";
import TheCartOrderContacts from "./TheCartOrderContacts.vue";
import TheCartOrderReceivingAddress from "./TheCartOrderReceivingAddress.vue";
import TheCartOrderPay from "./TheCartOrderPay.vue";
import TheCartOrderComment from "./TheCartOrderComment.vue";
import CartIcon from "../icons/CartIcon.vue";
import EmptyCartIcon from "../icons/EmptyCartIcon.vue";
import TheCartEmpty from "./TheCartEmpty.vue";

export default {
  name: "TheCartPage",
  components: {
    TheCartEmpty,
    EmptyCartIcon,
    CartIcon,
    TheCartResult,
    TheCartPositions,
    TireTrack,
    TheCartOrderContacts,
    TheCartOrderReceivingAddress,
    TheCartOrderPay,
    TheCartOrderComment,
  },
  computed: {
    ...mapState('cart', {
      'checkout': 'checkout',
      'politicUrl': 'politicUrl',
      'loading': 'loading',
      'loadingText': 'loadingText'
    }),
    ...mapState('order', {
      'name': 'name',
      'phone': 'phone',
      'clientType': 'clientType',
      'organization': 'organization',
      'errors': 'errors'
    }),
    ...mapGetters('cart', {
      'total': 'total',
      'count': 'count'
    })
  },
  methods: {
    ...mapActions({
      'loadCheckout': 'cart/loadCheckout',
      'loadPoliticUrl': 'cart/loadPoliticUrl',
      'send': 'order/send',
    }),
    async sendOrder() {
      this.setLoading(true);
      this.setLoadingText('Оформляем заказ...')
      const success = await this.send(false);
      this.setLoading(false);

      if (!success) {
        await this.$nextTick();
        this.scrollToFirstValidationError();
      }
    },
    scrollToFirstValidationError() {
      const error = this.$el.querySelector('.cart-errors__error');
      if (!error) {
        return;
      }

      const block = error.closest('.cart-order-block') || error;
      block.scrollIntoView({behavior: 'smooth', block: 'center'});
    },
    setLoading(value) {
      this.$store.commit('cart/setLoading', value);
    },
    setLoadingText(value) {
      this.$store.commit('cart/setLoadingText', value);
    }
  },

  mounted() {
    this.loadCheckout();
    this.loadPoliticUrl();
  }
}
</script>
